import * as ActionTypes from '../constants';
import { baseUrl } from './../index';
import axios from 'axios';


export default function(state={}, action) {
    switch(action.type) {
        case ActionTypes.REQUEST_REGISTRATION_VERIFY: 
            return {
                ...state,
                loading: true,
                error:false,
                errInfo: null,
                response: null
            }
            case ActionTypes.REGISTRATION_VERIFY_STATUS: 
            return {
                ...state,
                loading: false,
                response: action.res,              
                error: false,
                errInfo: null
            }
            case ActionTypes.ERROR_REGISTRATION_VERIFY:
                return {
                    ...state,
                    loading: false,
                    error: true,
                    errInfo: action.err,
                    response: null
                }
        case ActionTypes.CLEAR_REGISTRATION_VERIFY_INFO:
            return { }
        default :  return state
    }

}

const dispatchRequestRegistrationOtpVerify = data => ({
    type: ActionTypes.REQUEST_REGISTRATION_VERIFY,
    data
})

const dispatchReceivedRegistrationOtpVerify = res => ({
    type: ActionTypes.REGISTRATION_VERIFY_STATUS,
    res
})

const dispatchErrorRegistrationOtpVerify = err => ({
    type: ActionTypes.ERROR_REGISTRATION_VERIFY,
    err
})

export const dispatchClearRegistrationOtpVerify = () => ({
    type: ActionTypes.CLEAR_REGISTRATION_VERIFY_INFO
})

export function verifyOtpForRegistration (verify_reg_otp) { 
    let data;
    return (dispatch, getState) => {    
        const store = getState();
        const { registration } = store || {};
        const { response } = registration || {};
        // console.log(registration , "Asdksdhbhasjkdaskda", response);
        const { first_name=null, last_name=null, phone=null, email=null, username=null } = response || {};

        data = {
            first_name, last_name, phone, email, verify_reg_otp, username 
        }

        dispatch(dispatchRequestRegistrationOtpVerify(data));    
        
        axios({
            method: 'POST',
            url: `${baseUrl}/api/register_verify`,
            data          
        })          
        .then(({data}) => {            
            dispatch(dispatchReceivedRegistrationOtpVerify({data}));            
        })
        .catch(e => {
            dispatch(dispatchErrorRegistrationOtpVerify(e.response));
        })            
    }

}